// API configuration
// Use environment variable for API base path, default to '/data' for production
export const API_BASE_PATH = process.env.REACT_APP_API_BASE_URL || '/data';

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
    // Remove leading slash from endpoint if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${API_BASE_PATH}/${cleanEndpoint}`;
};